import { render, staticRenderFns } from "./SocialInfo.vue?vue&type=template&id=5bc553a0&scoped=true&"
import script from "./SocialInfo.vue?vue&type=script&lang=js&"
export * from "./SocialInfo.vue?vue&type=script&lang=js&"
import style0 from "./SocialInfo.vue?vue&type=style&index=0&id=5bc553a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc553a0",
  null
  
)

export default component.exports